import React from 'react';
import {Link} from "react-router-dom";

import {RtPage} from '../../../server/routes/route-types.js'

interface PaginationProps {
    pages?: RtPage[];
}

export default function Pagination({pages}: PaginationProps) {

	return (
		<>
		{
			pages &&
			<>
				<br />
				<nav aria-label="...">
					<ul className="pagination">
						{
							pages.map((page, indexKey) => {
								return (
									<li className={"page-item" + (page.Disabled ? " disabled" : (page.Current ? " active" : 
										(page.Optional ? " page-optional" : "")))} key={indexKey}>
	
									{
										page.Disabled ?
											<span className="page-link">{page.Text}</span>
											:
										<>
											{
												page.Current ?
													<span className="page-link">
														{page.Text}
														<span className="sr-only">(current)</span>
													</span>
												:
												<>
													{
														page.Optional ?
															<Link 
																to={page.Link}
																className="page-link" 
															>
																{page.Text}
															</Link>
														:
															<Link 
																to={page.Link}
																className="page-link" 
															>
																{page.Text}
															</Link>
													}
												</>
											}
										</>
									}	
									</li>
								)
							})
						}
					</ul>
			</nav>
		</>    
		}
	</>
	)
}
